import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_3 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_4 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_5 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_8 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_9 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_10 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "row justify-content-center" }
const _hoisted_15 = { class: "col-lg-4 col-sm-4" }
const _hoisted_16 = { class: "col-lg-4 col-sm-4" }
const _hoisted_17 = { class: "col-lg-4 col-sm-4" }
const _hoisted_18 = { class: "row justify-content-center" }
const _hoisted_19 = { class: "col-lg-4 col-md-6" }
const _hoisted_20 = { class: "col-lg-4 col-md-6" }
const _hoisted_21 = { class: "col-lg-4 col-md-6" }
const _hoisted_22 = { class: "row justify-content-center" }
const _hoisted_23 = { class: "col-xl-6" }
const _hoisted_24 = { class: "col-xl-6" }
const _hoisted_25 = { class: "row justify-content-center" }
const _hoisted_26 = { class: "col-lg-4" }
const _hoisted_27 = { class: "col-lg-4" }
const _hoisted_28 = { class: "col-lg-4" }
const _hoisted_29 = { class: "row justify-content-center" }
const _hoisted_30 = { class: "col-xxl-4 col-lg-4" }
const _hoisted_31 = { class: "col-xxl-4 col-lg-4" }
const _hoisted_32 = { class: "col-xxl-4 col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RevenueGrowthChart = _resolveComponent("RevenueGrowthChart")!
  const _component_LeadConversionChart = _resolveComponent("LeadConversionChart")!
  const _component_TotalOrdersChart = _resolveComponent("TotalOrdersChart")!
  const _component_AnnualProfitChart = _resolveComponent("AnnualProfitChart")!
  const _component_TicketsResolvedChart = _resolveComponent("TicketsResolvedChart")!
  const _component_InProgressChart = _resolveComponent("InProgressChart")!
  const _component_TicketsDueChart = _resolveComponent("TicketsDueChart")!
  const _component_TicketsNewOpenChart = _resolveComponent("TicketsNewOpenChart")!
  const _component_WelcomeBack = _resolveComponent("WelcomeBack")!
  const _component_TotalCourses = _resolveComponent("TotalCourses")!
  const _component_TotalEnrolled = _resolveComponent("TotalEnrolled")!
  const _component_TotalMentors = _resolveComponent("TotalMentors")!
  const _component_TotalCustomersChart = _resolveComponent("TotalCustomersChart")!
  const _component_TotalOrdersChartTwo = _resolveComponent("TotalOrdersChartTwo")!
  const _component_TotalRevenueChart = _resolveComponent("TotalRevenueChart")!
  const _component_ProjectsOverview = _resolveComponent("ProjectsOverview")!
  const _component_ProjectsRoadmapChart = _resolveComponent("ProjectsRoadmapChart")!
  const _component_CoursesSalesChart = _resolveComponent("CoursesSalesChart")!
  const _component_TimeSpentChart = _resolveComponent("TimeSpentChart")!
  const _component_OurTopCourses = _resolveComponent("OurTopCourses")!
  const _component_ProjectsAnalysisChart = _resolveComponent("ProjectsAnalysisChart")!
  const _component_TeamMembers = _resolveComponent("TeamMembers")!
  const _component_WorkingSchedule = _resolveComponent("WorkingSchedule")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RevenueGrowthChart)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LeadConversionChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TotalOrdersChart)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AnnualProfitChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TicketsResolvedChart)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_InProgressChart)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_TicketsDueChart)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_TicketsNewOpenChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_WelcomeBack)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_TotalCourses)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_TotalEnrolled)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_TotalMentors)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_TotalCustomersChart)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_TotalOrdersChartTwo)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_TotalRevenueChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_ProjectsOverview)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_ProjectsRoadmapChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_CoursesSalesChart)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_TimeSpentChart)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_OurTopCourses)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_ProjectsAnalysisChart)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_TeamMembers)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_WorkingSchedule)
      ])
    ])
  ]))
}